export * from "modules/DealerLocationDetails/components/AiTablet";
export * from "modules/DealerLocationDetails/components/CustomerCommunication";
export * from "modules/DealerLocationDetails/components/DmsSystem";
export * from "modules/DealerLocationDetails/components/General";
export * from "modules/DealerLocationDetails/components/Integrations";
export * from "modules/DealerLocationDetails/components/KeylabelKeylocker";
export * from "modules/DealerLocationDetails/components/LocationDetailActions";
export * from "modules/DealerLocationDetails/components/LocationDetailHeader";
export * from "modules/DealerLocationDetails/components/Service";
export * from "modules/DealerLocationDetails/components/Tyres";
export * from "modules/DealerLocationDetails/components/Workorder";
